import SharedLangToggle from '../../../packages/ui/LangToggle';
import { useLang, setLang } from '../lib/i18n';

// 语言开关 = **共享组件 + 网页的语言单例**。
// 共享那份是哑组件(只收 {lang, onChange})—— 因为桌面没有网页这个
// useSyncExternalStore 单例,它把语言存在自己的 localStorage 里。
// 状态提到外面,组件就两端都能用;样式和结构只有一份。
export function LangToggle() {
  return <SharedLangToggle lang={useLang()} onChange={setLang} />;
}
